import { Box, Button, Flex, Heading, List, Text } from '@chakra-ui/react'
import React from 'react'
import { useColorModeValue } from '../../../components/ui/color-mode'
import { LuCircleCheck } from 'react-icons/lu'
import { useTranslation } from 'react-i18next'

const OurPricing = () => {

    const cardColor = useColorModeValue('white', 'gray.900')
    const textGhost = useColorModeValue('gray.700', 'gray.200')
    const {t} = useTranslation()

  return (
    <Flex
        px={{md: 'inherit', '2xl': "19%", base: 4}}
        py={{'2xl' :20, base: 10}}
        overflow={'hidden'}
        position={'relative'}
        mb={10}
    >
        <Box w={'full'}>
            <Flex gap={{ md: 10, base: 4 }} align={'center'} flexDir={'column'}>
                <Heading maxW={'500px'} textAlign={'center'} fontFamily={'Poppins'} letterSpacing={-1.5} lineHeight={1.1} fontSize={{ md: '4xl', '2xl': '5xl', base: '2xl' }} >
                   {t('pricingTitleServiceOne')}
                </Heading>
                <Text fontSize={{'2xl': 'xl', base: 'md'}} textAlign={'center'} maxW={'600px'}>
                     {t('pricingDescriptionServiceOne')}
                </Text>
            </Flex>


            <Flex justify={'center'} flexDir={{ md: 'row', base: 'column' }} gap={10} mt={20}>

                <Box h={'max-content'} boxShadow={'md'} bgColor={cardColor}  w={{ '2xl' :'400px', base: 'full'}} rounded={24} p={8}>
                    <Heading fontFamily={'Onest'} letterSpacing={-0.8}>
                       {t('pricingOption1TitleServiceOne')}
                    </Heading>
                    <Text mt={1} color={textGhost}>
                        {t('pricingOption1DescriptionServiceOne')}
                    </Text>


                    {/* <Heading mt={6} fontSize={'4xl'} fontFamily={'Outfit'}>
                        20% <Span fontSize={'md'} fontWeight={'normal'}>of the collected amount</Span>
                    </Heading> */}


                    <List.Root mt={4} borderTop={'1px solid'} borderColor={useColorModeValue('gray.100', 'gray.800')} pt={4} gap="2" variant="plain" align="center" fontSize={'sm'}>
                        <List.Item>
                            <List.Indicator asChild color="green.500">
                            <LuCircleCheck />
                            </List.Indicator>
                            {t('pricingOption1ServicesOne.feature1')}
                        </List.Item>
                        <List.Item>
                            <List.Indicator asChild color="green.500">
                            <LuCircleCheck />
                            </List.Indicator>
                            {t('pricingOption1ServicesOne.feature2')}
                        </List.Item>
                        <List.Item>
                            <List.Indicator asChild color="green.500">
                            <LuCircleCheck />
                            </List.Indicator>
                            {t('pricingOption1ServicesOne.feature3')}
                        </List.Item>
                        <List.Item>
                            <List.Indicator asChild color="green.500">
                            <LuCircleCheck />
                            </List.Indicator>
                            {t('pricingOption1ServicesOne.feature4')}
                        </List.Item>
                        <List.Item>
                            <List.Indicator asChild color="green.500">
                            <LuCircleCheck />
                            </List.Indicator>
                            {t('pricingOption1ServicesOne.feature5')}
                        </List.Item>
                    </List.Root>


                    <Button mt={10} fontFamily={'Momo Trust Display'} w={'full'} rounded={'full'} size={'lg'}> {t('callToAction')} </Button>

                </Box>


                <Box boxShadow={'md'} bgColor={cardColor}  w={{ '2xl' :'400px', base: 'full'}} rounded={24} p={8}>
                    <Heading fontFamily={'Onest'} letterSpacing={-0.8}>
                        {t('pricingOption2TitleServiceOne')}
                    </Heading>
                    <Text mt={1} color={textGhost}>
                        {t('pricingOption2DescriptionServiceOne')}
                    </Text>


                    {/* <Heading mt={6} fontSize={'4xl'} fontFamily={'Outfit'}>
                        25% <Span fontSize={'md'} fontWeight={'normal'}>of the collected amount</Span>
                    </Heading> */}


                    <List.Root mt={4} borderTop={'1px solid'} borderColor={useColorModeValue('gray.100', 'gray.800')} pt={4} gap="2" variant="plain" align="center" fontSize={'sm'}>
                        <List.Item>
                            <List.Indicator asChild color="green.500">
                            <LuCircleCheck />
                            </List.Indicator>
                            {t('pricingOption2ServicesOne.feature1')}
                        </List.Item>
                        <List.Item>
                            <List.Indicator asChild color="green.500">
                            <LuCircleCheck />
                            </List.Indicator>
                            {t('pricingOption2ServicesOne.feature2')}
                        </List.Item>
                        <List.Item>
                            <List.Indicator asChild color="green.500">
                            <LuCircleCheck />
                            </List.Indicator>
                            {t('pricingOption2ServicesOne.feature3')}
                        </List.Item>
                        <List.Item>
                            <List.Indicator asChild color="green.500">
                            <LuCircleCheck />
                            </List.Indicator>
                            {t('pricingOption2ServicesOne.feature4')}
                        </List.Item>
                        <List.Item>
                            <List.Indicator asChild color="green.500">
                            <LuCircleCheck />
                            </List.Indicator>
                            {t('pricingOption2ServicesOne.feature5')}
                        </List.Item>
                        <List.Item>
                            <List.Indicator asChild color="green.500">
                            <LuCircleCheck />
                            </List.Indicator>
                            {t('pricingOption2ServicesOne.feature4')}
                        </List.Item>
                        <List.Item>
                            <List.Indicator asChild color="green.500">
                            <LuCircleCheck />
                            </List.Indicator>
                            {t('pricingOption2ServicesOne.feature5')}
                        </List.Item>
                    </List.Root>


                    <Button mt={10} fontFamily={'Momo Trust Display'} w={'full'} rounded={'full'} size={'lg'}> {t('callToAction')} </Button>

                </Box>

            </Flex>

        </Box>
    </Flex>
  )
}

export default OurPricing